export const SET_ACTIVE_IMAGE = 'setActiveImageGallery';
export const SHOW_ALL_PHOTOS = 'showAllPhotosGallery';

export const GET_GALLERY_PENDING = 'getGalleryPending';
export const GET_GALLERY_FULFILLED = 'getGalleryFulfilled';
export const GET_GALLERY_REJECTED = 'getGalleryRejected';
